<template>
    <v-layout align-center justify-center>
    <v-flex xs12 sm8 md8 lg5 text-xs-center>
        <v-avatar class="mb-4" size="300px">
            <img src="img/metsatuotto.svg" alt="metsatuotto-logo">
        </v-avatar>
        <p class="body-1">
            Mitä sinun metsäsi tuottaa? Selvitä Metsätuottosi ja löydä vinkit, kuinka saat metsäsi tuottamaan entistä enemmän näköistäsi tuottoa.
        </p>
        <p class="body-1"> 
            Metsä on aina tuottoisa ja arvokas. Metsänomistajana päätät mitä metsäsi tuottaa ja saat metsän tuottamaan entistä monimuotoisemmin hoitamalla metsiäsi. Jos et vielä ole metsänomistaja mutta haluat tai aiot olla - Metsätuotto vauhdittaa sinut alkuun metsänomistajuudessa!
        </p>
        <v-btn class="mb-4 title white--text" color="#1b7a36" v-on:click="startQuiz">Aloita testi</v-btn>
        <v-divider class="mb-4 short-divider"></v-divider>
        <p class="body-1">
            Metsätuotto on toteutettu Metsäinen innostaa -hankkeessa. Hankkeen toteuttavat Suomen metsäkeskus, Suomen 4H-liitto ja Lapin ammattikorkeakoulu. Hankkeen on rahoittanut Lapin ELY-keskus Manner-Suomen maaseudun kehittämisohjelmasta 2014-2020.
        </p>
        <v-container xs12>
            <v-layout row  wrap>
            <v-flex xs6 md6>
                <v-card flat tile class="v-cardi">
                    <v-img class="footer-logos" src="img/2016_metsakeskus_pysty.png" height="75px" contain />
                </v-card>
            </v-flex>
            <v-flex xs6 md6>
                <v-card flat tile class="v-cardi">
                    <v-img class="footer-logos" src="img/lapinamk_cmyk.svg" height="75px" contain />
                </v-card>
            </v-flex>
            <v-flex xs6 md6>
                <v-card flat tile class="v-cardi">
                    <v-img class="footer-logos" src="img/4H_RGB.png" height="75px" contain />
                </v-card>
            </v-flex>
            <v-flex xs6 md6>
                <v-card flat tile class="v-cardi">
                    <v-img class="footer-logos" src="img/ELY.svg" height="75px" contain />
                </v-card>
            </v-flex>
            <v-flex xs6 md6>
                <v-card flat tile class="v-cardi">
                    <v-img class="footer-logos" src="img/maaseutu.svg" height="75px"  contain />
                </v-card>
            </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Intro',
  computed: {
    ...mapState('metsanomistaja', ['currentPoints', 'profiles'])
  },
  methods: {
    startQuiz() {
      this.$store.dispatch('metsanomistaja/startQuiz', {router: this.$router});
    }
  },
  mounted() {
    this.$store.dispatch('metsanomistaja/fetchQuestions');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.application .theme--light.v-card, .theme--light .v-card {
    background:#f8fafa;
}

#app > div > main > div > div > div > div > div > div > div {
    margin-bottom: 35px;
}

.short-divider {
    width: 75%;
    margin-left: auto;
    margin-right: auto;
}

.start-button {
    background-color: #1b7a36;
    color: #fefefe;
}
</style>
